import { render, staticRenderFns } from "./AlumnoCrearCuenta.vue?vue&type=template&id=16bdb986"
import script from "./AlumnoCrearCuenta.vue?vue&type=script&lang=js"
export * from "./AlumnoCrearCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports